import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "./TailoredTravelSolutions.css";
import Heading from "../../../utls/Heading";

const TailoredTravelSolutions = () => {
  return (
    <>
      <div className="ttSolutions-section">
        <div className="container">
          <div className="row ps-2 ps-md-0">
            <div className="col-lg-6">
              <Heading className="customheadings">
                <span>Personalized Travel</span> Solutions Crafted for Your
                Style and Budget
              </Heading>
              <p className="mt-md-3 mt-md-4 mt-3 fs5 parap">
                Welcome to Blueberry Travel! We understand every corporate
                traveler has their own set of travel requirements. That’s why we
                offer customized travel solutions designed to fit the unique
                needs of your organization.{" "}
              </p>
              <p className="mt-md-4 mt-2 fs5 parap">
                Holding multiple industry awards and a commitment to setting new
                standards, we’re always keen on delivering top-grade service.
                Our Code of Conduct accreditation ensures we meet and exceed
                your expectations.
              </p>
              <p className="mt-md-4 mt-2 fs5 parap">
                Ready to upgrade your business travel? Connect with us today and
                experience a journey full of excitement, safety, and truly
                exceptional.
              </p>
            </div>

            <div className="col-lg-6 mt-lg-0 mt-md-3 mt-4">
              <div className="d-flex flex-column justify-content-center align-items-center">
                <div className="tts-box">
                  <div className="tts-box-txt">
                    <LazyLoadImage
                      effect="blur"
                      src="https://blueberrywebsites.azureedge.net/bbt/icons/101a.png"
                      alt=""
                      className="tts-globe"
                      loading="lazy"
                    />
                    <h5 className="headings">Global Reach, Local Insight</h5>
                    <p className=" framep">
                      We combine global scale with thorough market knowledge to
                      ensure maximum savings and customized solutions for your
                      travel needs. Our agility allows us to tackle today’s
                      challenges and prepare for the future of business travel.{" "}
                    </p>
                  </div>
                </div>
                <div className="tts-box mt-4">
                  <div className="tts-box-txt">
                    <LazyLoadImage
                      effect="blur"
                      src="https://blueberrywebsites.azureedge.net/bbt/icons/101b.png"
                      alt=""
                      className="tts-spiral"
                      loading="lazy"
                    />
                    <h5 className="headings">Seamless, Reliable, Adaptive</h5>
                    <p className=" framep">
                      Our consultative, curated approach delivers flawless,
                      flexible corporate travel solutions that are customized
                      according to your needs. These solutions deliver strategic
                      results now and well into the future.
                    </p>
                  </div>
                </div>
                <div className="tts-box mt-4">
                  <div className="tts-box-txt">
                    <LazyLoadImage
                      effect="blur"
                      src="https://blueberrywebsites.azureedge.net/bbt/icons/101c.png"
                      alt=""
                      className="tts-stars"
                      loading="lazy"
                    />
                    <h5 className="headings">Your Feedback, Our Roadmap</h5>
                    <p className=" framep">
                      Your input shapes the future of our corporate travel
                      solutions. We prioritize your needs in every newly
                      launched product, ensuring you’re the first to access the
                      most relevant and impactful solutions.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TailoredTravelSolutions;
